import { render, staticRenderFns } from "./BaseFiles.vue?vue&type=template&id=acc02f7c&scoped=true&"
import script from "./BaseFiles.vue?vue&type=script&lang=ts&"
export * from "./BaseFiles.vue?vue&type=script&lang=ts&"
import style0 from "./BaseFiles.vue?vue&type=style&index=0&id=acc02f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc02f7c",
  null
  
)

export default component.exports